import { render, staticRenderFns } from "./BuildingFormFields.vue?vue&type=template&id=0f5ab3c0"
import script from "./BuildingFormFields.vue?vue&type=script&lang=js"
export * from "./BuildingFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports